import { Link } from 'react-router-dom';

function FindOutMore() {
  return (
    <div className="about__findoutmore-container">
      <div className="about__findoutmore-wrapper row">
        <div className="about__findoutmore-content column right-border">
          <div className="about__findoutmore-title">
            <h1>확실한 전문성</h1>
          </div>
          <div className="about__findoutmore-text">
            <p>
              본사의 천연 영양보충제는 최첨단 추출법과 가공법을 사용해
              생산됩니다. 이는 원료들이 건강에 최대한 도움이 되도록 효과를
              유지하게 만들어줍니다.
            </p>
            <p>
              저희는 최고의 품질을 가진 제품을 위해 계속해서 연구하고 혁신성을
              추구하는 등, 생산과 보완에 대해 책임감과 윤리 의식을 가지고
              접근합니다.
            </p>
          </div>
          <div className="about__findoutmore-button">
            <Link to="/commitment">
              <button className="about__button">더 알아보기</button>
            </Link>
          </div>
        </div>
        <div className="about__findoutmore-content column">
          <div className="about__findoutmore-title">
            <h1>고객 관리</h1>
          </div>
          <div className="about__findoutmore-text">
            <p>
              저희는 뉴질랜드에 본부를 둔 고객관리 팀이 있습니다. 필요하다면
              이메일을 보내주세요.
            </p>
            <p>전 세계로의 배송과 통관을 돕고 있습니다.</p>
            <p className="about__findoutmore-email">
              📧 admin@purelifespanworld.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FindOutMore;
